import React from 'react';

import SelectFilter from 'components/search_sidebar/select_filter';
import Wrapper from './wrapper';

import type { Filters } from './types';

const scheduledOption = { label: 'Scheduled Tasks', value: 'scheduled' };
const tbdOption = { label: 'Unscheduled Tasks', value: 'tbd' };

type Slice = Pick<Filters, 'tbd'>;
interface Props extends Slice {
  onChange: (changes: Slice) => void;
}

export default function TasksIndexFilters({ tbd, onChange }: Props) {
  return (
    <Wrapper>
      <SelectFilter
        autoWidth
        className="mr-2"
        options={[scheduledOption, tbdOption]}
        value={tbd ? tbdOption : scheduledOption}
        onChange={({ value }) => onChange({ tbd: value === tbdOption.value })}
      />
    </Wrapper>
  );
}
